import "./TripleGraficoAnalisis.css";
import { useContext } from "react";
import { DarkModeContext } from "../../context/DarkModeContext";
import { formatearAPeso } from "../../helpers/formatearAPeso";
import {
  calcularMetricasAnalisis,
  numeroSeguro,
  porcentaje,
} from "../../helpers/metricasAnalisis";

const TripleGraficoAnalisis = ({ datosBack }) => {
  const { darkMode } = useContext(DarkModeContext);
  const { debito, credito } = datosBack;

  const ticketItems = [
    { label: "Debito", value: numeroSeguro(debito) },
    { label: "Credito", value: numeroSeguro(credito) },
  ];
  const ticketMax = Math.max(...ticketItems.map((item) => item.value), 1);

  // Unica fuente de verdad compartida con las cards superiores.
  const {
    cuotasAgrupadas,
    totalCuotas,
    unPago: unPagoVenta,
    enCuotas: enCuotasVenta,
    debito: debitoVenta,
    credito: creditoVenta,
    total: totalVenta,
    cantidadOperaciones,
  } = calcularMetricasAnalisis(datosBack);
  const debitoPorcentaje = porcentaje(debitoVenta, totalVenta);
  const creditoPorcentaje = porcentaje(creditoVenta, totalVenta);

  return (
    <section
      translate="no"
      className="container py-analisis-grafica aliado-analisis-breakdown"
    >
      <article className={darkMode ? "bg-grafica-dark" : "bg-grafica"}>
        <h2 className="fs-18-a-16">Ticket promedio</h2>
        <div className="aliado-analisis-ticket-list">
          {ticketItems.map((item) => (
            <div className="aliado-analisis-ticket-item" key={item.label}>
              <span className="aliado-analisis-ticket-track">
                <span
                  style={{ height: `${porcentaje(item.value, ticketMax)}%` }}
                />
              </span>
              <strong>{formatearAPeso(item.value)}</strong>
              <span>{item.label}</span>
            </div>
          ))}
        </div>
      </article>

      <article className={darkMode ? "bg-grafica-dark" : "bg-grafica"}>
        <h2 className="fs-18-a-16">Composicion de las ventas</h2>
        <div className="aliado-analisis-sharebar">
          <span
            className="aliado-analisis-sharebar-dark"
            style={{ flexGrow: creditoVenta || 1 }}
          >
            {creditoPorcentaje}% credito
          </span>
          <span
            className="aliado-analisis-sharebar-accent"
            style={{ flexGrow: debitoVenta || 1 }}
          >
            {debitoPorcentaje}% debito
          </span>
        </div>
        <div className="aliado-analisis-table-wrap">
          <table className="aliado-analisis-table">
            <thead>
              <tr>
                <th>Modalidad</th>
                <th>Monto</th>
                <th>% monto</th>
                <th>Operaciones</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Debito</td>
                <td>{formatearAPeso(debitoVenta)}</td>
                <td>{debitoPorcentaje}%</td>
                <td>-</td>
              </tr>
              <tr>
                <td>Credito</td>
                <td>{formatearAPeso(creditoVenta)}</td>
                <td>{creditoPorcentaje}%</td>
                <td>-</td>
              </tr>
              <tr className="aliado-analisis-subrow">
                <td>1 Pago</td>
                <td>{formatearAPeso(unPagoVenta)}</td>
                <td>{porcentaje(unPagoVenta, totalVenta)}%</td>
                <td>-</td>
              </tr>
              <tr className="aliado-analisis-subrow">
                <td>Cuotas</td>
                <td>{formatearAPeso(enCuotasVenta)}</td>
                <td>{porcentaje(enCuotasVenta, totalVenta)}%</td>
                <td>-</td>
              </tr>
              <tr className="aliado-analisis-total-row">
                <td>Total</td>
                <td>{formatearAPeso(totalVenta)}</td>
                <td>100%</td>
                <td>{cantidadOperaciones || "-"}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </article>

      <article className={darkMode ? "bg-grafica-dark" : "bg-grafica"}>
        <h2 className="fs-18-a-16">Ventas en cuotas</h2>
        <div className="aliado-analisis-table-wrap">
          <table className="aliado-analisis-table">
            <thead>
              <tr>
                <th>Cuotas</th>
                <th>Monto</th>
                <th>% monto</th>
              </tr>
            </thead>
            <tbody>
              {cuotasAgrupadas.map((grupo) => (
                <tr key={grupo.label}>
                  <td>{grupo.label}</td>
                  <td>{formatearAPeso(grupo.monto)}</td>
                  <td>{porcentaje(grupo.monto, totalCuotas)}%</td>
                </tr>
              ))}
              <tr className="aliado-analisis-total-row">
                <td>Total</td>
                <td>{formatearAPeso(totalCuotas)}</td>
                <td>{totalCuotas ? "100%" : "0%"}</td>
              </tr>
            </tbody>
          </table>
        </div>
        
      </article>
    </section>
  );
};

export default TripleGraficoAnalisis;
